import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Header from "../Header";
import Principal from "../../pages/Principal";
import Estabelecimentos from "../../pages/Estabelecimentos";
import TabEntregadores from "../TabsEntregadores";
import TabCupons from "../TabsCupons";
import { getUser } from "../../services/Auth";
import "./style.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { Link, Switch, Route } from "react-router-dom";
import NotificacoesPush from "../../pages/Notificacoes";
import TabsGerenciamento from "../TabsGerenciamento";
import TabsFinanceiro from "../TabsFinanceiro";
import Integracao from "../../pages/Integracao";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      <Box p={3}>{children}</Box>
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `wrapped-tab-${index}`,
    "aria-controls": `wrapped-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function TabsWrappedLabel(props) {
  const classes = useStyles();
  const [value, setValue] = useState("/app/principal");
  const [user, setUser] = useState(null);

  useEffect(() => {
    async function fetchData() {
      const user = await getUser();
      if (user) {
        setUser(user);
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (props.location.pathname === "/") {
      props.history.push("/app/principal");
    }
  }, [props]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      {user ? (
        <AppBar position="static" style={{ backgroundColor: "white" }}>
          <Header></Header>

          {user && user.tipo === "master" ? (
            <Tabs
              value={value}
              variant="scrollable"
              scrollButtons="auto"
              indicatorColor="primary"
              textColor="primary"
              onChange={handleChange}
              aria-label="wrapped label tabs example"
            >
              <Tab
                value={"/app/principal"}
                label="Principal"
                to="/app/principal"
                wrapped
                component={Link}
                {...a11yProps(1)}
              />
              <Tab
                value="/app/estabelecimentos"
                label="Estabelecimentos"
                to="/app/estabelecimentos"
                component={Link}
                {...a11yProps(2)}
              />
              <Tab
                label="Entregadores"
                value="/app/entregadores"
                to="/app/entregadores"
                component={Link}
                {...a11yProps(5)}
              />
              <Tab
                label="Financeiro"
                value="/app/financeiro"
                to="/app/financeiro"
                component={Link}
                {...a11yProps(5)}
              />
              <Tab
                label="Gerenciamento"
                value="/app/gerenciamento"
                to="/app/gerenciamento"
                component={Link}
                {...a11yProps(5)}
              />
              <Tab
                label="Notificações Push"
                value="/app/notificacoes"
                to="/app/notificacoes"
                component={Link}
                {...a11yProps(7)}
              />
              <Tab
                value="/app/cupons"
                label="Cupons"
                component={Link}
                to="/app/cupons"
                {...a11yProps(9)}
              />
              <Tab
                value="/app/integracoes"
                label="Integrações"
                component={Link}
                to="/app/integracoes"
                {...a11yProps(9)}
              />
            </Tabs>
          ) : (
            <Tabs
              value={"/app/entregadores"}
              indicatorColor="primary"
              textColor="primary"
              onChange={handleChange}
              aria-label="wrapped label tabs example"
            >
              <Tab
                label="Entregadores"
                value="/app/entregadores"
                to="/app/entregadores"
                component={Link}
                {...a11yProps(5)}
              />
            </Tabs>
          )}

          <div id="loader" class="loader" style={{ height: 10 }}>
            <div class="loaderBar"></div>
          </div>

          {user.tipo === "master" ? (
            <Switch>
              <Route
                path="/app/principal"
                render={() => {
                  return (
                    <div className="container-div">
                      <Principal />
                    </div>
                  );
                }}
              />
              <Route
                path="/app/estabelecimentos"
                render={() => {
                  return (
                    <div className="container-div">
                      <Estabelecimentos />
                    </div>
                  );
                }}
              />

              <Route
                path="/app/financeiro"
                render={() => {
                  return (
                    <div className="container-div">
                      <TabsFinanceiro />
                    </div>
                  );
                }}
              />

              <Route
                path="/app/entregadores"
                render={() => {
                  return (
                    <div className="container-div">
                      <TabEntregadores />
                    </div>
                  );
                }}
              />

              <Route
                path="/app/gerenciamento"
                render={() => {
                  return (
                    <div className="container-div">
                      <TabsGerenciamento />
                    </div>
                  );
                }}
              />

              <Route
                path="/app/notificacoes"
                render={() => {
                  return (
                    <div className="container-div">
                      <NotificacoesPush />
                    </div>
                  );
                }}
              />
              <Route
                path="/app/cupons"
                render={() => {
                  return (
                    <div className="container-div">
                      <TabCupons />
                    </div>
                  );
                }}
              />
              <Route
                path="/app/integracoes"
                render={() => {
                  return (
                    <div className="container-div">
                      <Integracao />
                    </div>
                  );
                }}
              />
            </Switch>
          ) : (
            <Switch>
              <Route
                path="/app/entregadores"
                render={() => {
                  return (
                    <div className="container-div">
                      <TabEntregadores />
                    </div>
                  );
                }}
              />
            </Switch>
          )}
        </AppBar>
      ) : null}

      <ToastContainer></ToastContainer>
    </div>
  );
}
